const { BANK_TRANSFER_REQUEST_STATUS, BANK_TRANSFER_REQUEST_RESERVATION_STATUS } = require('arbitrip-common/general/constants');

// A request can cover several reservations, and Finance can cancel one of them while the request
// itself moves on (e.g. is later rejected). `reservation_request_status` is THIS booking's own entry
// on the request (packages/mongodb `getBankTransferRequestPopulate`), so the booking's status is read
// through it rather than off the request:
// - entry `cancelled`: the booking is closed on that request — no request status at all;
// - entry `cancelled_pending_review`: the booking reads as cancellation pending, whatever the request says;
// - entry `active`, or absent (legacy single-reservation requests, older servers): the request's status.
function getBookingBankTransferRequestStatus(booking) {
	const request = booking?.bank_transfer_request;
	if (!request) {
		return null;
	}

	const entryStatus = request.reservation_request_status;
	if (entryStatus === BANK_TRANSFER_REQUEST_RESERVATION_STATUS.CANCELLED) {
		return null;
	}
	if (entryStatus === BANK_TRANSFER_REQUEST_RESERVATION_STATUS.CANCELLED_PENDING_REVIEW) {
		return BANK_TRANSFER_REQUEST_STATUS.CANCELLED_PENDING_REVIEW;
	}

	return request.status || null;
}

// True when the request's own status describes this booking (entry active or absent).
function isBookingActiveOnBankTransferRequest(booking) {
	const entryStatus = booking?.bank_transfer_request?.reservation_request_status;
	return ![
		BANK_TRANSFER_REQUEST_RESERVATION_STATUS.CANCELLED,
		BANK_TRANSFER_REQUEST_RESERVATION_STATUS.CANCELLED_PENDING_REVIEW,
	].includes(entryStatus);
}

module.exports = {
	getBookingBankTransferRequestStatus,
	isBookingActiveOnBankTransferRequest,
};
